module.exports = __webpack_public_path__ + "img/BO.6f0f3a99.svg";